import { render, staticRenderFns } from "./ListSoftwaresByServerSection.vue?vue&type=template&id=207b7226&"
import script from "./ListSoftwaresByServerSection.vue?vue&type=script&lang=js&"
export * from "./ListSoftwaresByServerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports